// extracted by mini-css-extract-plugin
export default {"fourHalfs":"myInternal_fourHalfs__UwVXw"};